import { render, staticRenderFns } from "./StartClassNotificationEdit.vue?vue&type=template&id=34104b72&scoped=true"
import script from "./StartClassNotificationEdit.vue?vue&type=script&lang=js"
export * from "./StartClassNotificationEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34104b72",
  null
  
)

export default component.exports